// M0 local playground: two dropzones feeding the blend view, no backend.
// The agent's first end-to-end check that parse -> distill -> computeBlend ->
// render works in a real browser.

import { useState } from "react";
import { Page } from "../components/Layout.tsx";
import { Dropzone } from "../components/Dropzone.tsx";
import { BlendView } from "../components/BlendView.tsx";
import type { DistilledProfile } from "../lib/types.ts";

export default function DevBlend() {
  const [a, setA] = useState<DistilledProfile | null>(null);
  const [b, setB] = useState<DistilledProfile | null>(null);

  return (
    <Page testid="screen-dev-blend" wide>
      <h1 className="mb-4 text-2xl font-semibold text-ink-900">Local blend playground</h1>
      <div className="grid gap-4 sm:grid-cols-2">
        <div>
          <p className="mb-2 text-sm text-ink-400">Person A (e.g. dave.zip)</p>
          <Dropzone onParsed={setA} compact />
        </div>
        <div>
          <p className="mb-2 text-sm text-ink-400">Person B (e.g. sarah.zip)</p>
          <Dropzone onParsed={setB} compact />
        </div>
      </div>

      {a && b ? (
        <div className="mt-8">
          <BlendView profileA={a} profileB={b} nameA="Person A" nameB="Person B" />
        </div>
      ) : (
        <p className="mt-8 text-center text-ink-400">Drop two exports to see the blend.</p>
      )}
    </Page>
  );
}
